import { Button } from "antd";
// 查询对象
export const queryData = [
  {
    label: "创建时间",
    dataIndex: "createTime",
    type: "DatePickers",
    params: {},
  },
  {
    label: "额度更新时间",
    dataIndex: "lastUpdateDate",
    type: "DatePickers",
    params: {},
  },
  {
    label: "办税人",
    dataIndex: "taxClerk",
    type: "Input",
    params: {
      placeholder: "请输入",
    },
  },
  {
    label: "关键字搜索",
    dataIndex: "query",
    type: "Input",
    params: {
      placeholder: "请输入开票方主体、纳税人识别号...",
    },
  },
];
// 导航
export const breads = [
  {
    label: "代办业务",
    path: "/business",
  },
];
// 开票渠道
export enum ISSUE_CHANNEL {
  BW = "百望云",
  HX = "航信",
  MANUAL = "电子税务局",
}
// 开票周期
export enum TAX_FILLING_PERIOD {
  M = "月",
  Q = "季",
}
